import { PropsWithChildren } from 'react'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface Props
  extends PropsWithChildren<{
    // Whether the children should render on the native app. Default: true
    nativeApp?: boolean
  }> {}

export const Mobile = ({ children, nativeApp = true }: Props) => {
  const { isMobile, isIOSNative } = useResponsiveDesign()

  if (!isMobile) {
    return null
  }

  if (isIOSNative && !nativeApp) {
    return null
  }

  return <>{children}</>
}
